import { useNavigate } from 'react-router-dom'

import { JOIN_PARTNER_URL } from '@/features/join/pages/JoinPartnerPage'
import { Main2Menu } from '@/styles/Web/Main/main2menu_styled'
import { MainLayout } from '@/styles/Web/Main/styled'

const Main2MenuSection = () => {
  const navigate = useNavigate()
  const handleClick = (to: string) => {
    navigate(to)
  }

  return (
    <MainLayout>
      <Main2Menu>
        <div className="menu-list">
          <button
            className="service_join"
            onClick={() => (window.location.href = JOIN_PARTNER_URL)}
          />
          <button className="use_info" onClick={() => handleClick('usage')} />
          <button className="contact" onClick={() => handleClick('mypage')} />
          <button className="sticker" onClick={() => handleClick('sticker')} />
        </div>
      </Main2Menu>
    </MainLayout>
  )
}

export default Main2MenuSection
